import React, { useState } from 'react';
import { Tooltip } from '@mui/material';
import { BarItem } from '@nivo/bar';

const EmptyTooltip = () => null;

export default function InvoiceBar(props) {
  const [followPointer, setFollowPointer] = useState(true);
  const { bar, tooltip: Content } = props;
  return <Tooltip
    title={<Content {...bar} {...bar.data} />}
    placement="right"
    followCursor={followPointer}
    enterTouchDelay={0}
    PopperProps={{ modifiers: [
      { name: 'flip', options: { fallbackPlacements: ['left', 'bottom', 'top'], altAxis: false, padding: 12 } },
      { name: 'preventOverflow', options: { padding: 12, altAxis: true } },
    ] }}
    componentsProps={{ tooltip: { sx: { bgcolor: 'transparent', p: 0, maxWidth: 'min(320px, calc(100vw - 24px))' } } }}
  >
    <g className="analytics-invoice-bar" onMouseEnter={() => setFollowPointer(true)} onFocus={() => setFollowPointer(false)}>
      <BarItem {...props} tooltip={EmptyTooltip} />
    </g>
  </Tooltip>;
}
